import type { PriceMap } from "@/lib/pricing"
import type { AddOnId, Gender } from "@/lib/quiz/types"
import { addOnPriceKey } from "@/lib/quiz/product-mapping"
import { memberPriceChf } from "@/lib/pricing/member-prices"

const FREE_ADDONS: ReadonlySet<AddOnId> = new Set(["trend_overlay"])

/** Membership total = blood-test fee + each paid add-on at member price
 *  (falling back to ad-hoc price when no fixed member figure exists).
 *  Free add-ons (trend overlay) contribute nothing. */
export function membershipTotalChf(
  prices: PriceMap,
  selectedAddOns: AddOnId[],
  gender: Gender | undefined
): number {
  return (
    Number(prices.blood) +
    selectedAddOns.reduce((acc, id) => {
      if (FREE_ADDONS.has(id)) return acc
      const key = addOnPriceKey(id, gender)
      if (!key) return acc
      const member = memberPriceChf(prices, key)
      return acc + (member ?? Number(prices[key]))
    }, 0)
  )
}
